/* CADFORGE — shared front-end behaviour: reveals, count-up, magnetic buttons */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal-on-scroll (fades + heading clip-rise) ---------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cf-reveal:not(.cf-in), .cf-rise:not(.cf-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cf-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cf-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i, 4) * 45) + 'ms';
      io.observe(el);
    });
  }

  /* ---- count-up numbers -------------------------------------------------- */
  function animateCount(el) {
    var raw = el.getAttribute('data-count') || el.textContent;
    var m = raw.match(/^(\D*)(\d[\d,]*)(.*)$/); // prefix / digits / suffix
    if (!m) { return; }                          // nothing numeric (e.g. "AU")
    var prefix = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suffix = m[3];
    var dur = 1100, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);          // easeOutCubic
      el.textContent = prefix + Math.round(target * eased).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCount(root) {
    var els = (root || document).querySelectorAll('.cf-count:not([data-counted])');
    els.forEach(function (el) {
      el.setAttribute('data-count', el.textContent.trim());
      el.setAttribute('data-counted', '1');
    });
    if (reduce || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- magnetic buttons (subtle cursor pull) ----------------------------- */
  function initMagnet(root) {
    if (reduce || window.matchMedia('(pointer: coarse)').matches) { return; }
    (root || document).querySelectorAll('.cf-magnet').forEach(function (el) {
      if (el.dataset.magnet) return; el.dataset.magnet = '1';
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) * 0.22;
        var y = (ev.clientY - r.top - r.height / 2) * 0.30;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- interactive product tile (cursor-driven 3D tilt + light) ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(pointer: coarse)').matches) { return; }
    (root || document).querySelectorAll('.cf-tilt').forEach(function (el) {
      if (el.dataset.tilt) return; el.dataset.tilt = '1';
      var inner = el.querySelector('.cf-tilt__in');
      if (!inner) return;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'rotateY(' + (px * 13).toFixed(2) + 'deg) rotateX(' + (-py * 13).toFixed(2) + 'deg)';
        el.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { inner.style.transform = ''; });
    });
  }

  function initAll(root) { initReveal(root); initCount(root); initMagnet(root); initTilt(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.CADForge = { initReveal: initReveal, initAll: initAll };
})();
